class CoderreviewedController {
  constructor(
    $scope,
    DTOptionsBuilder,
    DTColumnBuilder,
    User,
    CONST,
    FunctionService,
    Constants,
    materialButtons,
    datePicker,
    $rootScope
  ) {
    this.datatableApi;
    this.user = User.getUser();
    this.name = "Coding Review Overview";
    this.separationString = "";
    this.TAudited = 0;
    this.TFinalised = 0;
    this.TApproved = 0;

    this.locale = "en-au";

    this.url =
      WEBSERVICEURL + "/dataagility/api/service.medicalrecords/reviewed/?";
    this.initUrl =
      this.url +
      "startDate=" +
      moment().locale(this.locale).subtract(1, "month").format("L") +
      "&endDate=" +
      moment().locale(this.locale).subtract(1, "days").format("L");

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.functionSettings = response.functionSettings;

        Constants.campusData().then(function successCallback(response) {
          if (
            $scope.vm.user.role !== "Administrator" &&
            $scope.vm.functionSettings.LimitCampusDropDown &&
            $scope.vm.functionSettings.LimitCampusDropDown.isActive
          ) {
            let campusOptions = [];
            if (typeof $scope.vm.user.campus === "string") {
              campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
            } else {
              campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
            }
            $scope.vm.campusOptions = campusOptions;
            $scope.vm.campus.selectedCampus = campusOptions;
          } else {
            $scope.vm.campusOptions = response;
          }
        });

        $scope.vm.separationString =
          response.functionSettings.SeparationString.valueString;
      }
    );

    materialButtons.render();

    materialButtons.processing();

    jQuery.fn.dataTable.Api.register("sum()", function () {
      return this.flatten().reduce(function (a, b) {
        if (typeof a === "string") {
          a = a.replace(/[^\d.-]/g, "") * 1;
        }
        if (typeof b === "string") {
          b = b.replace(/[^\d.-]/g, "") * 1;
        }

        return a + b;
      }, 0);
    });

    $scope.drawCallback = function (nRow, aData, index) {
      $scope.vm.TAudited = this.api().column(1).data().sum();
      $scope.vm.TFinalised = this.api().column(3).data().sum();
      $scope.vm.TApproved = this.api().column(4).data().sum();
    };

    $scope.initCallback = function (
      nRow,
      aData,
      iDisplayIndex,
      iDisplayIndexFull
    ) {
      // Datatables has finished init
      // Initialise searching
      if ($scope.vm.datatableApi) return;

      $scope.vm.datatableApi = this.api();

      // setup search filters
      search();

      // set the table to a fixed height, so it never collapsed up and down
      $("#auditTable").closest(".dataTables_scrollBody").height(300);
    };

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption("ajax", {
        headers: {
          Authorization: "Bearer " + $rootScope.globals.currentUser.token,
        },
        url: $scope.vm.initUrl,
        type: "GET",
        error: (xhr, error, thrown) => {
          if (thrown == "Unauthorized") {
            //window.location.replace(window.location.origin + '/login');
            console.log(
              "Unauthorized request with token: ",
              $rootScope.globals.currentUser.token
            );
          }
        },
      })
      .withDisplayLength(CONST.TABLEROWS)
      .withDataProp("data")
      .withOption("processing", true)
      .withOption("sAjaxDataProp", "")
      .withOption("bLengthChange", false)
      .withPaginationType("simple_numbers")
      .withOption("rowCallback", $scope.rowCallback)
      .withOption("drawCallback", $scope.drawCallback)
      .withOption("initComplete", $scope.initCallback)
      .withOption("scrollY", "300px")
      .withOption("scrollX", "auto")
      .withOption("aaSorting", [[0, "asc"]])
      .withOption("dom", '<"wrapper"rt<"table-footer"iBp>>')
      .withButtons([
        {
          extend: "print",
          text: "",
        },
        {
          extend: "csvHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          extend: "excelHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          text: "",
          action: function (e, dt, node, config) {
            dt.ajax.reload();
          },
        },
      ])

      .withColumnFilter({
        //sPlaceHolder: "head:after",
        aoColumns: [
          { type: "select" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
        ],
      });

    function yesNo(data) {
      return data === true ? "Y" : "N";
    }

    this.dtColumns = [
      DTColumnBuilder.newColumn("PCCLModifiedUser")
        .withTitle("User")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalAudited")
        .withTitle("Total Coded")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalFinalised")
        .withTitle("Total Audited")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalReviewed")
        .withTitle("Total Reviewed")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalNotReviewed")
        .withTitle("Total Not Yet Reviewed")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
    ];

    this.startDatePicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, "month"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(1, "month")
          .format("L"),
      },
    };
    this.endDatePicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, "days"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(1, "days")
          .format("L"),
      },
    };

    datePicker.autoClose($scope);

    function setDefaultDate() {
      $scope.vm.startDatePicker.input.date = moment()
        .locale($scope.vm.locale)
        .subtract(1, "month");
      $scope.vm.startDatePicker.input.dateFormatted = moment()
        .locale($scope.vm.locale)
        .subtract(1, "month")
        .format("L");

      $scope.vm.endDatePicker.input.date = moment()
        .locale($scope.vm.locale)
        .subtract(1, "days");
      $scope.vm.endDatePicker.input.dateFormatted = moment()
        .locale($scope.vm.locale)
        .subtract(1, "days")
        .format("L");
    }

    this.changeData = changeData;

    function changeData() {
      var campus = "";
      if (
        $scope.vm.functionSettings.LimitCampusDropDown &&
        $scope.vm.functionSettings.LimitCampusDropDown.isActive
      ) {
        if (
          $scope.vm.user.role !== "Administrator" &&
          $scope.vm.campus.selectedCampus.length === 0
        ) {
          campus = $scope.vm.user.campus;
        } else {
          campus = $scope.vm.campus.selectedCampus;
        }
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
      var newUrl =
        $scope.vm.url +
        "startDate=" +
        $scope.vm.startDatePicker.input.dateFormatted +
        "&endDate=" +
        $scope.vm.endDatePicker.input.dateFormatted +
        "&campus=" +
        checkParam(campus);
      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
    }

    function checkParam(param) {
      if (param.length !== 0) {
        return encodeURIComponent(param.join());
      } else {
        return "";
      }
    }

    function search() {
      // delete any global searches previously applied
      if ($.fn.dataTable.ext.search.length === 1)
        $.fn.dataTable.ext.search.shift();

      var auditTable = $scope.vm.datatableApi;
      auditTable.search("").draw();

      // re-draw tabele on datepicker close
      $scope.$on("lx-date-picker__close-start", function (e, id) {
        $scope.vm.changeData();
      });
    }

    // bind the datatable instance to an object to monitor loading
    this.dtInstanceCallback = dtInstanceCallback;

    function dtInstanceCallback(dtInstance) {
      $scope.dtInstance = dtInstance._renderer;
    }

    this.selectCallback = selectCallback;
    function selectCallback(_newValue, _oldValue) {
      $scope.vm.changeData();
    }

    function filterCampus(modifier) {
      $scope.vm.campus.selectedCampus = [];
      if (modifier === "add") {
        $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
      }
    }

    this.filterSwap = filterSwap;
    function filterSwap(thisFilter, thisModifier) {
      switch (thisFilter) {
        case "campus":
          if (thisModifier === "add") {
            filterCampus("add");
          } else {
            filterCampus("minus");
          }
          break;
        default:
          break;
      }
    }
  }
}

export default CoderreviewedController;



// WEBPACK FOOTER //
// ./client/app/common/reports/coderreviewed/coderreviewed.controller.js